(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daynightfaq"] && !Shopify.designMode) return;
  try {
    
  const initProductNewFaq = (root = document) => {
    const scope = root instanceof Element ? root : document;
    const section = scope.querySelector('[data-product-faq]');
    if (!(section instanceof HTMLElement)) return;

    const getThemeFromUrl = () => {
      const query = new URLSearchParams(window.location.search);
      const urlTheme = (query.get('dn_theme') || '').toLowerCase();
      if (urlTheme === 'night' || urlTheme === 'day') return urlTheme;
      return null;
    };

    const getThemeFromProductSection = () => {
      const host = document.querySelector('.day-night-product-page[data-theme]');
      if (!(host instanceof HTMLElement)) return null;
      const hostTheme = (host.dataset.theme || '').toLowerCase();
      if (hostTheme === 'night' || hostTheme === 'day') return hostTheme;
      return null;
    };

    const applyThemeState = (nextTheme) => {
      const safeTheme = nextTheme === 'night' ? 'night' : 'day';
      section.classList.toggle('is-night', safeTheme === 'night');
      section.classList.toggle('is-day', safeTheme === 'day');
    };

    const resolveTheme = (eventTheme) => {
      if (eventTheme === 'night' || eventTheme === 'day') return eventTheme;
      return getThemeFromProductSection() || getThemeFromUrl() || (section.classList.contains('is-night') ? 'night' : 'day');
    };

    applyThemeState(resolveTheme(null));
    section.classList.add('is-enhanced');

    const items = section.querySelectorAll('.product-new-faq__item');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const syncInitialState = (item, answer) => {
      if (item.open) {
        item.classList.add('is-expanded');
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
      } else {
        item.classList.remove('is-expanded');
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
      }
    };

    const closeItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;
      if (prefersReducedMotion) {
        item.classList.remove('is-expanded');
        item.open = false;
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
        return;
      }

      item.dataset.animating = 'true';
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.getBoundingClientRect();
      item.classList.remove('is-expanded');
      answer.style.opacity = '0';
      answer.style.transform = 'translateY(-6px)';
      answer.style.maxHeight = '0px';

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.open = false;
        item.dataset.animating = 'false';
      };
      answer.addEventListener('transitionend', onEnd);
    };

    const openItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;
      if (prefersReducedMotion) {
        item.classList.add('is-expanded');
        item.open = true;
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
        return;
      }

      item.dataset.animating = 'true';
      item.open = true;
      item.classList.add('is-expanded');
      answer.style.maxHeight = '0px';
      answer.style.opacity = '1';
      answer.style.transform = 'translateY(0)';
      answer.getBoundingClientRect();
      answer.style.maxHeight = `${answer.scrollHeight}px`;

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.dataset.animating = 'false';
        answer.style.maxHeight = 'none';
      };
      answer.addEventListener('transitionend', onEnd);
    };

    items.forEach((item) => {
      if (!(item instanceof HTMLDetailsElement) || item.dataset.pnfBound === 'true') return;
      const summary = item.querySelector('.product-new-faq__summary');
      const answer = item.querySelector('.product-new-faq__answer');
      if (!(summary instanceof HTMLElement) || !(answer instanceof HTMLElement)) return;

      item.dataset.pnfBound = 'true';
      syncInitialState(item, answer);

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });
    });

    if (section.dataset.themeBound === 'true') return;
    section.dataset.themeBound = 'true';

    const handleThemeEvent = (event) => {
      applyThemeState(resolveTheme(event?.detail?.theme));
    };

    window.addEventListener('dn:theme-change', handleThemeEvent);
    document.addEventListener('dn:theme-change', handleThemeEvent);
    window.addEventListener('popstate', () => applyThemeState(resolveTheme(null)));

    if ('MutationObserver' in window) {
      const observer = new MutationObserver(() => {
        applyThemeState(resolveTheme(null));
      });
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-theme']
      });
    }
  };

  initProductNewFaq(document);
  document.addEventListener('DOMContentLoaded', () => initProductNewFaq(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    initProductNewFaq(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-new-faq-product"] && !Shopify.designMode) return;
  try {
    
  const initProductNewFaq = (root = document) => {
    const scope = root instanceof Element ? root : document;
    const section = scope.querySelector('[data-product-faq]');
    if (!(section instanceof HTMLElement)) return;

    const getThemeFromUrl = () => {
      const query = new URLSearchParams(window.location.search);
      const urlTheme = (query.get('dn_theme') || '').toLowerCase();
      if (urlTheme === 'night' || urlTheme === 'day') return urlTheme;
      return null;
    };

    const getThemeFromProductSection = () => {
      const host = document.querySelector('.day-night-product-page[data-theme]');
      if (!(host instanceof HTMLElement)) return null;
      const hostTheme = (host.dataset.theme || '').toLowerCase();
      if (hostTheme === 'night' || hostTheme === 'day') return hostTheme;
      return null;
    };

    const applyThemeState = (nextTheme) => {
      const safeTheme = nextTheme === 'night' ? 'night' : 'day';
      section.classList.toggle('is-night', safeTheme === 'night');
      section.classList.toggle('is-day', safeTheme === 'day');
    };

    const resolveTheme = (eventTheme) => {
      if (eventTheme === 'night' || eventTheme === 'day') return eventTheme;
      return getThemeFromProductSection() || getThemeFromUrl() || (section.classList.contains('is-night') ? 'night' : 'day');
    };

    applyThemeState(resolveTheme(null));
    section.classList.add('is-enhanced');

    const items = section.querySelectorAll('.product-new-faq__item');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const syncInitialState = (item, answer) => {
      if (item.open) {
        item.classList.add('is-expanded');
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
      } else {
        item.classList.remove('is-expanded');
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
      }
    };

    const closeItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;
      if (prefersReducedMotion) {
        item.classList.remove('is-expanded');
        item.open = false;
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
        return;
      }

      item.dataset.animating = 'true';
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.getBoundingClientRect();
      item.classList.remove('is-expanded');
      answer.style.opacity = '0';
      answer.style.transform = 'translateY(-6px)';
      answer.style.maxHeight = '0px';

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.open = false;
        item.dataset.animating = 'false';
      };
      answer.addEventListener('transitionend', onEnd);
    };

    const openItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;
      if (prefersReducedMotion) {
        item.classList.add('is-expanded');
        item.open = true;
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
        return;
      }

      item.dataset.animating = 'true';
      item.open = true;
      item.classList.add('is-expanded');
      answer.style.maxHeight = '0px';
      answer.style.opacity = '1';
      answer.style.transform = 'translateY(0)';
      answer.getBoundingClientRect();
      answer.style.maxHeight = `${answer.scrollHeight}px`;

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.dataset.animating = 'false';
        answer.style.maxHeight = 'none';
      };
      answer.addEventListener('transitionend', onEnd);
    };

    items.forEach((item) => {
      if (!(item instanceof HTMLDetailsElement) || item.dataset.pnfBound === 'true') return;
      const summary = item.querySelector('.product-new-faq__summary');
      const answer = item.querySelector('.product-new-faq__answer');
      if (!(summary instanceof HTMLElement) || !(answer instanceof HTMLElement)) return;

      item.dataset.pnfBound = 'true';
      syncInitialState(item, answer);

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });
    });

    if (section.dataset.themeBound === 'true') return;
    section.dataset.themeBound = 'true';

    const handleThemeEvent = (event) => {
      applyThemeState(resolveTheme(event?.detail?.theme));
    };

    window.addEventListener('dn:theme-change', handleThemeEvent);
    document.addEventListener('dn:theme-change', handleThemeEvent);
    window.addEventListener('popstate', () => applyThemeState(resolveTheme(null)));

    if ('MutationObserver' in window) {
      const observer = new MutationObserver(() => {
        applyThemeState(resolveTheme(null));
      });
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-theme']
      });
    }
  };

  initProductNewFaq(document);
  document.addEventListener('DOMContentLoaded', () => initProductNewFaq(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    initProductNewFaq(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-new-faq"] && !Shopify.designMode) return;
  try {
    
  const initHomepageNewFaqAccordion = (root = document) => {
    const scope = root instanceof Element ? root : document;
    const items = scope.querySelectorAll('.homepage-new-faq__item');
    if (!items.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const syncInitialState = (item, answer) => {
      if (item.open) {
        item.classList.add('is-expanded');
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
      } else {
        item.classList.remove('is-expanded');
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
      }
    };

    const closeItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;

      if (prefersReducedMotion) {
        item.classList.remove('is-expanded');
        item.open = false;
        answer.style.opacity = '0';
        answer.style.transform = 'translateY(-6px)';
        answer.style.maxHeight = '0px';
        return;
      }

      item.dataset.animating = 'true';

      const startHeight = answer.scrollHeight;
      answer.style.maxHeight = `${startHeight}px`;
      answer.getBoundingClientRect();
      item.classList.remove('is-expanded');
      answer.style.opacity = '0';
      answer.style.transform = 'translateY(-6px)';
      answer.style.maxHeight = '0px';

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.open = false;
        item.dataset.animating = 'false';
        answer.style.maxHeight = '0px';
      };

      answer.addEventListener('transitionend', onEnd);
    };

    const openItem = (item, answer) => {
      if (item.dataset.animating === 'true') return;

      if (prefersReducedMotion) {
        item.classList.add('is-expanded');
        item.open = true;
        answer.style.opacity = '1';
        answer.style.transform = 'translateY(0)';
        answer.style.maxHeight = 'none';
        return;
      }

      item.dataset.animating = 'true';
      item.open = true;
      item.classList.add('is-expanded');
      answer.style.maxHeight = '0px';
      answer.style.opacity = '1';
      answer.style.transform = 'translateY(0)';
      answer.getBoundingClientRect();

      const targetHeight = answer.scrollHeight;
      answer.style.maxHeight = `${targetHeight}px`;

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        item.dataset.animating = 'false';
        answer.style.maxHeight = 'none';
      };

      answer.addEventListener('transitionend', onEnd);
    };

    items.forEach((item) => {
      if (!(item instanceof HTMLDetailsElement) || item.dataset.hnfBound === 'true') return;

      const summary = item.querySelector('.homepage-new-faq__summary');
      const answer = item.querySelector('.homepage-new-faq__answer');
      if (!(summary instanceof HTMLElement) || !(answer instanceof HTMLElement)) return;

      item.dataset.hnfBound = 'true';
      syncInitialState(item, answer);

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initHomepageNewFaqAccordion(document);
    },
    { once: true }
  );

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    initHomepageNewFaqAccordion(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
